(() => {
  let result = null;

  const getTreatmentOptions = ({ handle, variantId } = {}) => {
    const options = JSON.parse(
      document.querySelector("#custom-engraving-2026-data")?.textContent || "[]",
    );
    const matches = options.filter((option) =>
      option.engravingType !== "sidewall" &&
      (option.associatedProducts || []).some((product) =>
        handle ? product.handle === handle :
          (product.variantIds || [product.variantId]).some((id) => String(id) === String(variantId)),
      ),
    );
    // A product enters Treatment only when every remaining location is supported.
    if (!matches.length || !matches.every((option) =>
      option.engravingType === "caseback" &&
      option.treatmentEligible !== false &&
      Boolean(option.engravingServiceProduct && option.engravingServiceSku) &&
      (option.availableEngravingCustomizations || []).some((mode) =>
        mode === "upload-text" || (mode === "custom-icons" && option.customIcons?.length),
      ),
    )) return [];
    return matches;
  };

  const finish = (isTreatment, source, group = null) => {
    if (result) return;
    const assignedTreatment = isTreatment;

    // Preserve the existing flow for products outside the configured treatment.
    if (isTreatment) {
      try {
        const handle = window.location.pathname.match(/\/products\/([^/]+)/)?.[1];
        const eligible = handle && getTreatmentOptions({ handle }).length;
        if (!eligible) {
          isTreatment = false;
          source = "product-outside-treatment";
        }
      } catch (error) {
        isTreatment = false;
        source = "invalid-treatment-config";
      }
    }

    result = { isTreatment, assignedTreatment, source, group };
    document.documentElement.dataset.ogEngravingVariant = isTreatment
      ? "treatment"
      : "control";
    document.documentElement.dataset.ogEngravingSource = source;

    return result;
  };

  // The approved flow is now the default, independent of experiment assignment.
  // Keep the shared interface used by PDP and cart consumers.
  window.OGEngravingExperiment = {
    getTreatmentOption(criteria) {
      try { return getTreatmentOptions(criteria)[0] || null; }
      catch (error) { return null; }
    },
    getTreatmentOptions(criteria) {
      try { return getTreatmentOptions(criteria); }
      catch (error) { return []; }
    },
    whenReady(callback) {
      callback(result || finish(true, "production"));
    },
    getResult() { return result; },
  };
})();
